import { Link } from 'react-router'
import { Home } from 'lucide-react'

export default function NotFound() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-50 to-purple-50">
            <title>Página não encontrada (404) — Apoio a vítimas LGBTI+ | APAV</title>
            <meta name="description" content="A página que procura não existe ou foi removida. Regresse à página inicial do site da APAV sobre violência contra pessoas LGBTI+ para encontrar apoio." />
            <meta name="robots" content="noindex" />
            <div className="text-center px-6">
                <h1 className="text-9xl font-bold text-brand-600 mb-4">404</h1>
                <h2 className="text-3xl font-bold text-slate-900 mb-4">
                    Página não encontrada
                </h2>
                <p className="text-lg text-slate-600 mb-8 max-w-md mx-auto">
                    A página que procura não existe ou foi removida.
                </p>
                <Link
                    to="/"
                    className="btn-primary inline-flex items-center gap-2"
                >
                    <Home size={20} />
                    Voltar à página inicial
                </Link>
            </div>
        </div>
    )
}
